// Categorical color maps for the Reporting 2.0 charts, converted to hex from
// the flank-20 reference. Channel/device get fixed brand-ish colors; other
// categories fall back to the ordered SERIES palette by index.
export const CHANNEL_COLORS: Record<string, string> = {
  Display: '#0EA5E9',
  CTV: '#8B5CF6',
  OLV: '#EF4444',
  Audio: '#D946EF',
  Dooh: '#10B981',
  Search: '#6366F1',
  Social: '#EC4899',
  Google: '#F59E0B',
  Amazon: '#22C55E',
  Gaming: '#14B8A6',
  // Channel was renamed "Spotify Direct" -> "Direct Audio" (ribeye-api
  // migration 1785147000000); the old key never matched a stored value and
  // every Direct Audio row fell back to the SERIES cycle (flank#4868).
  'Direct Audio': '#1DB954',
  // GAM's two channels had no fixed entry, so their color depended on
  // position in the option list rather than being stable (flank#4868).
  'GAM Display': '#0369A1',
  'GAM Video': '#CA8A04',
};

// flank#4882: no live chart currently colors devices per-series — the
// Impressions by Device card (BreakdownCard) draws single-color bars, and the
// only component that accepts a per-row colorMap (DonutCard/Donut) isn't
// wired into any route. Keeping this would be unreferenced dead code with
// nowhere real to apply it; removed rather than wired in speculatively.

// Generic ordered palette for categories without a fixed color (products, etc.).
export const SERIES: string[] = [
  '#EA580C',
  '#0EA5E9',
  '#8B5CF6',
  '#10B981',
  '#F59E0B',
  '#EC4899',
  '#6366F1',
  '#14B8A6',
  '#EF4444',
  '#22C55E',
];

/**
 * Resolve a color for `label`: prefer an exact map key, then a case-insensitive
 * one, else cycle the generic SERIES. Case-insensitive because the callers
 * here pass the canonical `CHANNELS.NAME` value (via `channelFilterOptions`/
 * `ch.NAME`, not a raw per-DSP value), and that seeded vocabulary itself mixes
 * casing — upper-case "CTV"/"OLV" next to mixed-case "Dooh" — so an exact-case
 * map key is not guaranteed (flank#4868).
 */
export const colorFor = (label: string, map: Record<string, string> | undefined, index: number): string => {
  if (map) {
    if (map[label] !== undefined) return map[label];
    const lower = label.toLowerCase();
    const key = Object.keys(map).find(k => k.toLowerCase() === lower);
    if (key !== undefined) return map[key];
  }
  return SERIES[index % SERIES.length];
};
